module.exports = __webpack_public_path__ + "static/Happystudent-bro-cb41b9978ac7e6685176298357a9f42d.svg";